"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paramPathchange = void 0;
var urlTemplate = require('url-template');
function paramPathchange(url, request) {
    url = urlTemplate.parse(url).expand(request.pathParams);
    delete request.pathParams;
    return url;
}
exports.paramPathchange = paramPathchange;
